/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import {PackageCategoryEntity} from "types/entities/PackageCategoryEntity";

const CategoryDetailEventPackage = (props: {packageCategoryEntity: PackageCategoryEntity}) => {
    const {t} = useTranslation();
    return (
        <section className={"CategoryDetailEventPackage col-span-12"}>
            <div className={"flex flex-col gap-2 md:gap-4 font-poppins items-center text-black"}>
                <h2 className={"font-zuume italic font-black text-5xl md:text-6xl"}>{props.packageCategoryEntity.categoryInfo?.infoEventPackage?.title}</h2>
                <ol
                    className={
                        "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-[360px,360px] justify-center list-disc pl-6 marker:text-arbo-red gap-x-4 md:gap-x-6 lg:gap-x-8 xl:gap-x-12 lg:text-lg"
                    }
                >
                    {props.packageCategoryEntity.categoryInfo?.infoEventPackage?.values.map((item, index) => {
                        return <li key={index}>{item}</li>;
                    })}
                </ol>
            </div>
        </section>
    );
};

export default CategoryDetailEventPackage;
